export const pushmap={
  accountsreceivable:{
    name:'应收账单',
    to:'financemanger',
    targetTab:'accountsreceivable',

  },
  paymentvoucher:{
    name:'缴费凭证',
    to:"financemanger",
    targetTab:'paymentvoucher',
  },
  contractList:{
    name:'合同列表',
    to:"order",
    targetTab:'1',

  }
}
